import React, { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { TopNav } from "@/components/TopNav";
import { Footer } from "@/components/Footer";
import { RouteFallback } from "@/components/RouteFallback";
import { trackEvent } from "@/lib/api";

export function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    // Best-effort analytics pageview (drives the staff Metrics dashboard).
    const topicMatch = pathname.match(/^\/topic\/([^/]+)/);
    trackEvent({ path: pathname, topic_slug: topicMatch ? topicMatch[1] : null, event: "pageview" });
  }, [pathname]);
  return (
    <div className="App min-h-screen">
      <TopNav />
      <main>
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
